import { useTranslations } from "next-intl";
import { DoubleCheckOrderIcon } from "../_icons/doubleCheckOrderIcon";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";

export const DoubleCheckOrderBanner = () => {
  const t = useTranslations("DoubleCheckOrderBanner");
  return (
    <div
      data-testid={applyDataTestId(pom.banners.doubleCheckOrderBanner)}
      className="flex gap-5 bg-[#EEFBFC] rounded-lg px-4 mx-4 text-[#373737]"
    >
      <DoubleCheckOrderIcon className="py-[18px]" />
      <div data-testid={applyDataTestId(pom.banners.doubleCheckOrderText)} className="text-xs py-4">
        <span className="font-semibold">{t("title")} </span>
        <span>
          {t("message")}
        </span>
      </div>
    </div>
  );
};
